
// param: product
export const fitsInMailbox = ({ width, height, depth, weigth }) => {
  if (width && height && depth) {
    return width <= 375 && height <= 31 && depth <= 255
  }
  return false;
}

// fitsInMailBox: boolean
export const toggleMailBoxFitProperties = (mailboxCheckbox, { width, height, depth, weight }) => {
  const defined = val => val !== null && val !== undefined
  if (width === '') width = 0
  if (height === '') height = 0
  if (depth === '') depth = 0
  if (weight === '') weight = 0
  const unsetValues = !width && !height && !depth
  const valuesAreSet = defined(width) && defined(height) && defined(depth)

  if (mailboxCheckbox) {
      width = 220
      height = 8
      depth = 220
      weight = 0.1
  } else {
      width = 375
      height = 32
      depth = 375
  }

  return { width, height, depth, weight }
}

export const getPrice = price => {
  if (price === '---') {
    return 0.0
  }
  if (typeof price === 'string') {
    return parseFloat(price.replace(/,/, '.'))
  }

  return price
}

export const SUPPLIER_ORDER_STATUS = {
  new: {
    str: 'New',
    color: {
      backgroundColor: '#17a2b8'
    }
  },
  sent_to_supplier: {
    str: 'Sent to supplier',
    color: {
      backgroundColor: '#0081C9'
    }
  },
  quotation_received: {
    str: 'Quotation received',
    color: {
      backgroundColor: '#F48F32'
    }
  },
  quotation_accepted: {
    str: 'Quotation accepted',
    color: {
      backgroundColor: '#397678'
    }
  },
  quotation_rejected: {
    str: 'Quotation rejected',
    color: {
      backgroundColor: '#dc3545'
    }
  },
  waiting_for_information: {
    str: 'Waiting for information',
    color: {
      backgroundColor: '#ffc107'
    }
  },
  creating_sample: {
    str: 'Creating sample',
    color: {
      backgroundColor: '#6c757d'
    }
  },
  product_ready: {
    str: 'Product ready',
    color: {
      backgroundColor: '#28a745'
    }
  }
}
